const shoMore = document.getElementById("yas_showmre");
const wrappshoMore = shoMore.closest('div');
const detailsShoMore = shoMore.closest('details');

function yas_showmre() {
   
  if (wrappshoMore.style.maxHeight === "160px") {
    wrappshoMore.style.maxHeight = 'unset';
    shoMore.innerHTML = shoMore.getAttribute('data-lesst');
    shoMore.classList.add("less_content");
  } else {
    wrappshoMore.style.maxHeight = '160px';
    shoMore.innerHTML = shoMore.getAttribute('data-readt');
    shoMore.classList.remove("less_content");
  }
} 


document.addEventListener("DOMContentLoaded", () => {

  wrappshoMore.style.maxHeight = '160px';
  wrappshoMore.style.overflow = 'hidden';
  wrappshoMore.style.position = 'relative';

});
